import { Button, Group, Progress, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

type TrainingUsageProps = {
  availableTrainings: number
  totalTrainings: number
  onUpgrade: () => void
}

export const TrainingUsage = ({
  availableTrainings,
  totalTrainings,
  onUpgrade
}: TrainingUsageProps) => {
  const progress = (availableTrainings / totalTrainings) * 100

  return (
    <Group justify="space-between">
      <Stack gap="xs">
        <Text size="sm">
          <FormattedMessage
            id="subscriptions.usage.modelTrainings.remaining"
            values={{ count: availableTrainings }}
          />
        </Text>

        <Progress value={progress} size="sm" w={160} color="green" />
      </Stack>

      <Button size="compact-xs" onClick={onUpgrade}>
        <FormattedMessage id="subscriptions.upgrade" />
      </Button>
    </Group>
  )
}
